/* NØBASIC PRO — JS global (vanilla, sin librerías). Cargado con defer desde layout/theme.liquid. */
(function () {
  'use strict';
  var NB = window.NB = window.NB || {};
  var cfg = NB.cfg || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- almacenamiento seguro ---------- */
  function lsGet(k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* ---------- dinero ---------- */
  function money(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    cents = Number(cents) || 0;
    function f(n, dec, th, ds) {
      var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return s.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return f(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(cents, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return f(cents, 2, "'", '.');
      return f(cents, 2, ',', '.');
    });
  }
  NB.money = money;

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'nb-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }
  NB.toast = toast;

  /* ---------- carrito lateral ---------- */
  var drawer = null, lastFocus = null;
  function getDrawer() { return drawer || (drawer = $('[data-nb-drawer]')); }
  function setBubbles(count) {
    $$('cart-icon').forEach(function (el) { if (typeof el.renderCartBubble === 'function') el.renderCartBubble(count); });
  }
  function renderCart(html) {
    var d = getDrawer(); if (!d || !html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-nb-drawer-inner]');
    var cur = d.querySelector('[data-nb-drawer-inner]');
    if (fresh && cur) cur.replaceWith(fresh);
    var c = d.querySelector('[data-nb-count]');
    if (c) setBubbles(parseInt(c.getAttribute('data-nb-count'), 10) || 0);
    initUpsell();
  }
  function openCart() {
    var d = getDrawer(); if (!d) { location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var x = d.querySelector('[data-nb-close]'); if (x) x.focus();
    initUpsell();
  }
  function closeCart() {
    var d = getDrawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function refreshCart() {
    return fetch('/?sections=nb-cart').then(function (r) { return r.json(); }).then(function (j) { renderCart(j['nb-cart']); });
  }
  function addToCart(id, qty, btn) {
    if (btn) { btn.classList.add('is-busy', 'is-loading'); btn.setAttribute('aria-busy', 'true'); }
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }], sections: 'nb-cart', sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message || 'No se pudo agregar.'); throw new Error('add'); }
        if (res.j.sections && res.j.sections['nb-cart']) renderCart(res.j.sections['nb-cart']); else return refreshCart();
      })
      .then(function () { return true; })
      .catch(function () { return false; })
      .finally(function () { if (btn) { btn.classList.remove('is-busy', 'is-loading'); btn.removeAttribute('aria-busy'); } });
  }
  NB.addToCart = addToCart; NB.openCart = openCart;
  function changeLine(key, qty) {
    var d = getDrawer(); if (d) d.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: 'nb-cart', sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message || 'No hay más stock de este talle.'); return refreshCart(); }
        if (res.j.sections && res.j.sections['nb-cart']) renderCart(res.j.sections['nb-cart']); else return refreshCart();
      })
      .finally(function () { if (d) d.classList.remove('is-busy'); });
  }

  /* ---------- recomendaciones (Completá el look) ---------- */
  function cardsFromHtml(html) {
    var t = document.createElement('div'); t.innerHTML = html;
    return { cards: $$('.nb-card', t), empty: !!t.querySelector('[data-nb-reco-empty]'), fallback: $$('[data-nb-fallback] .nb-card', t) };
  }
  function loadReco(pid, exclude, limit) {
    var base = '/recommendations/products?product_id=' + pid + '&limit=' + (limit || 8) + '&section_id=nb-reco&intent=';
    var pick = function (list) {
      return list.filter(function (c) { return exclude.indexOf(c.getAttribute('data-handle')) === -1; });
    };
    return fetch(base + 'complementary').then(function (r) { return r.text(); }).then(function (h) {
      var a = cardsFromHtml(h); var list = pick(a.empty ? [] : a.cards.filter(function (c) { return !c.closest('[data-nb-fallback]'); }));
      if (list.length) return list;
      return fetch(base + 'related').then(function (r) { return r.text(); }).then(function (h2) {
        var b = cardsFromHtml(h2); var l2 = pick(b.empty ? [] : b.cards.filter(function (c) { return !c.closest('[data-nb-fallback]'); }));
        if (l2.length) return l2;
        return pick(b.fallback.length ? b.fallback : a.fallback);
      });
    }).catch(function () { return []; });
  }
  function fillRow(container, cards, max) {
    container.innerHTML = '';
    cards.slice(0, max || 8).forEach(function (c) { container.appendChild(c); });
    initCards(container); syncFavs(); initRowArrows(container.closest('[data-nb-rowwrap]'));
    return cards.length;
  }
  function initUpsell() {
    var d = getDrawer(); if (!d) return;
    var box = d.querySelector('[data-nb-upsell]'); if (!box || box.dataset.done) return;
    box.dataset.done = '1';
    var ex = (box.getAttribute('data-exclude') || '').split(',');
    loadReco(box.getAttribute('data-pid'), ex, 10).then(function (cards) {
      var row = box.querySelector('[data-nb-upsell-row]');
      if (!cards.length || !row) { box.hidden = true; return; }
      fillRow(row, cards, 8); box.hidden = false;
    });
  }

  /* ---------- tarjetas ---------- */
  function initCard(card) {
    if (card.dataset.nbInit) return; card.dataset.nbInit = '1';
    var track = card.querySelector('[data-nb-track]');
    var bars = $$('.nb-card__bars span', card);
    var prev = card.querySelector('[data-nb-prev]'), next = card.querySelector('[data-nb-next]');
    if (track && bars.length) {
      var upd = function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        bars.forEach(function (b, n) { b.classList.toggle('is-on', n === i); });
        if (prev) prev.hidden = i <= 0;
        if (next) next.hidden = i >= bars.length - 1;
      };
      track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      var go = function (dir) { return function (e) { e.preventDefault(); e.stopPropagation(); track.scrollBy({ left: dir * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }; };
      if (prev) prev.addEventListener('click', go(-1));
      if (next) next.addEventListener('click', go(1));
    }
  }
  function initCards(root) { $$('[data-nb-card]', root).forEach(initCard); }

  /* ---------- favoritos ---------- */
  function getFavs() { var f = lsGet('nb-favs', []); return Array.isArray(f) ? f : []; }
  function syncFavs() {
    var favs = getFavs();
    $$('[data-nb-fav]').forEach(function (b) {
      var on = favs.indexOf(b.getAttribute('data-nb-fav')) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-nb-fav-count]').forEach(function (n) { n.textContent = favs.length; n.hidden = !favs.length; });
  }
  function toggleFav(h) {
    var favs = getFavs(); var i = favs.indexOf(h);
    if (i > -1) { favs.splice(i, 1); toast('Lo sacaste de favoritos'); } else { favs.unshift(h); toast('Guardado en favoritos'); }
    lsSet('nb-favs', favs.slice(0, 60)); syncFavs();
  }
  function injectHeaderFav() {
    if ($('.nb-hfav')) return;
    var cartLink = $('#header-component .action__cart') || $('.header-actions .action__cart') || $('.action__cart');
    if (!cartLink || !cartLink.parentNode) return;
    var a = document.createElement('a');
    a.href = cfg.favUrl || '/pages/favoritos'; a.className = 'nb-hfav'; a.setAttribute('aria-label', 'Favoritos');
    a.innerHTML = "<svg viewBox='0 0 24 24' aria-hidden='true'><path d='M12 20.5s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.7c0 5.6-7.5 10.2-7.5 10.2z'/></svg><span class='nb-hfav__n' data-nb-fav-count hidden>0</span>";
    cartLink.parentNode.insertBefore(a, cartLink);
  }

  /* ---------- carruseles de tarjetas (flechas en PC) ---------- */
  function initRowArrows(wrap) {
    if (!wrap) return;
    var row = wrap.querySelector('[data-nb-row]'); if (!row) return;
    var p = wrap.querySelector('[data-nb-row-prev]'), n = wrap.querySelector('[data-nb-row-next]');
    var upd = function () {
      if (p) p.hidden = row.scrollLeft <= 4;
      if (n) n.hidden = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    };
    if (!wrap.dataset.nbInit) {
      wrap.dataset.nbInit = '1';
      row.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      var step = function (d) { return function () { row.scrollBy({ left: d * row.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' }); }; };
      if (p) p.addEventListener('click', step(-1));
      if (n) n.addEventListener('click', step(1));
    }
    upd();
  }

  /* ---------- pestañas de la home ---------- */
  function initTabs(root) {
    $$('[data-nb-tabs]', root).forEach(function (box) {
      var tabs = $$('[role=tab]', box);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var on = o === t; o.setAttribute('aria-selected', on ? 'true' : 'false'); o.tabIndex = on ? 0 : -1;
            var pnl = document.getElementById(o.getAttribute('aria-controls')); if (pnl) pnl.hidden = !on;
          });
          var pnl = document.getElementById(t.getAttribute('aria-controls'));
          if (pnl) { initRowArrows(pnl.querySelector('[data-nb-rowwrap]')); var r = pnl.querySelector('[data-nb-row]'); if (r) r.scrollLeft = 0; }
          t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
        });
        t.addEventListener('keydown', function (e) {
          var i = tabs.indexOf(t);
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault(); var j = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; tabs[j].focus(); tabs[j].click();
          }
        });
      });
    });
  }

  /* ---------- acordeones (uno abierto a la vez) ---------- */
  function initAccordions(root) {
    $$('[data-nb-accs]', root).forEach(function (g) {
      var items = $$('details', g);
      items.forEach(function (d) {
        d.addEventListener('toggle', function () { if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; }); });
      });
    });
  }

  /* ---------- header: se esconde al bajar (celular) ---------- */
  function initHeaderHide() {
    if (!cfg.hideHeader) return;
    var html = document.documentElement; html.classList.add('nb-hide-on-scroll');
    var last = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (window.innerWidth < 750) {
          var menuOpen = document.querySelector('#header-component details[open], .header-drawer[open], dialog[open]');
          if (y > last + 6 && y > 120 && !menuOpen) html.classList.add('nb-hdr-up');
          else if (y < last - 6 || y < 120) html.classList.remove('nb-hdr-up');
        } else html.classList.remove('nb-hdr-up');
        last = y; ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- eventos globales (delegados) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var fav = t.closest('[data-nb-fav]');
    if (fav) { e.preventDefault(); e.stopPropagation(); toggleFav(fav.getAttribute('data-nb-fav')); return; }

    var qa = t.closest('[data-nb-qa-open]');
    if (qa) {
      e.preventDefault(); var card = qa.closest('.nb-card');
      $$('.nb-card.is-qa').forEach(function (c) { if (c !== card) c.classList.remove('is-qa'); });
      card.classList.add('is-qa'); qa.setAttribute('aria-expanded', 'true');
      var first = card.querySelector('.nb-size:not([disabled])'); if (first) first.focus();
      return;
    }
    var add = t.closest('[data-nb-add]');
    if (add && !add.disabled) {
      e.preventDefault();
      addToCart(add.getAttribute('data-nb-add'), 1, add).then(function (ok) {
        if (ok) { var c = add.closest('.nb-card'); if (c) c.classList.remove('is-qa'); if (!add.closest('[data-nb-drawer]')) openCart(); else toast('Agregado al carrito'); }
      });
      return;
    }
    if (!t.closest('.nb-card')) $$('.nb-card.is-qa').forEach(function (c) { c.classList.remove('is-qa'); });

    var cartTrigger = t.closest('.action__cart, a[href="/cart"], a[href$="/cart"], [data-nb-open-cart]');
    if (cartTrigger && !cartTrigger.closest('[data-nb-drawer]') && getDrawer() && document.body.getAttribute('data-template') !== 'cart') {
      e.preventDefault(); e.stopPropagation(); openCart(); return;
    }
    if (t.closest('[data-nb-close]') || t.matches('.nb-drawer__shade')) { e.preventDefault(); closeCart(); return; }

    var qbtn = t.closest('[data-nb-qty]');
    if (qbtn) { e.preventDefault(); changeLine(qbtn.getAttribute('data-key'), parseInt(qbtn.getAttribute('data-nb-qty'), 10)); return; }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = getDrawer(); if (d && d.classList.contains('is-open')) closeCart();
      $$('.nb-card.is-qa').forEach(function (c) { c.classList.remove('is-qa'); });
      var pnl = $('.nb-panel.is-open'); if (pnl) NB.closePanel(pnl);
    }
  });

  /* ---------- colección: filtros, vista y scroll infinito ---------- */
  NB.closePanel = function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; };
  function initCollection(root) {
    var col = $('[data-nb-col]', root); if (!col) return;
    var panel = $('[data-nb-panel]', col);
    $$('[data-nb-filter-open]', col).forEach(function (b) {
      b.addEventListener('click', function () { panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; var f = panel.querySelector('button,select,input'); if (f) f.focus(); });
    });
    $$('[data-nb-panel-close]', col).forEach(function (b) { b.addEventListener('click', function () { NB.closePanel(panel); }); });
    var form = $('[data-nb-filter-form]', col);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form), q = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') q.append(k, v); });
      location.href = location.pathname + (q.toString() ? '?' + q.toString() : '');
    });
    var grid = $('[data-nb-grid]', col);
    var btns = $$('[data-nb-view]', col);
    var applyView = function (n) {
      if (!grid) return; grid.setAttribute('data-cols', n);
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-nb-view') === String(n) ? 'true' : 'false'); });
    };
    var mobile = window.innerWidth < 750;
    var saved = lsGet(mobile ? 'nb-view-m' : 'nb-view-d', null);
    if (saved) applyView(saved);
    btns.forEach(function (b) { b.addEventListener('click', function () { var n = b.getAttribute('data-nb-view'); applyView(n); lsSet(window.innerWidth < 750 ? 'nb-view-m' : 'nb-view-d', n); }); });

    var more = $('[data-nb-more]', col);
    if (more && grid && 'IntersectionObserver' in window) {
      var loading = false;
      var load = function () {
        var a = more.querySelector('a[href]'); if (!a || loading) return; loading = true;
        more.classList.add('is-loading'); a.hidden = true;
        var sp = document.createElement('span'); sp.className = 'nb-spin'; sp.setAttribute('aria-label', 'Cargando'); more.appendChild(sp);
        fetch(a.href).then(function (r) { return r.text(); }).then(function (h) {
          var t = document.createElement('div'); t.innerHTML = h;
          var g = t.querySelector('[data-nb-grid]'); var m2 = t.querySelector('[data-nb-more]');
          if (g) { $$('.nb-card', g).forEach(function (c) { grid.appendChild(c); }); initCards(grid); syncFavs(); }
          if (m2) { more.replaceWith(m2); more = m2; } else more.remove();
          loading = false; if (more && more.isConnected) io.observe(more);
        }).catch(function () { loading = false; a.hidden = false; sp.remove(); });
      };
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { io.unobserve(x.target); load(); } }); }, { rootMargin: '600px 0px' });
      io.observe(more);
    }
  }

  /* ---------- vistos recientemente ---------- */
  function pushRecent(h) { var r = lsGet('nb-recent', []); if (!Array.isArray(r)) r = []; r = r.filter(function (x) { return x !== h; }); r.unshift(h); lsSet('nb-recent', r.slice(0, 12)); }
  function fetchCard(h) {
    return fetch('/products/' + encodeURIComponent(h) + '?section_id=card-render').then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { var d = document.createElement('div'); d.innerHTML = t; return d.querySelector('.nb-card'); }).catch(function () { return null; });
  }
  function renderHandles(handles, row) {
    return Promise.all(handles.map(fetchCard)).then(function (cards) { return fillRow(row, cards.filter(Boolean), 12); });
  }
  NB.renderHandles = renderHandles;

  /* ---------- página de producto ---------- */
  function initPDP(root) {
    var pdp = $('[data-nb-pdp]', root); if (!pdp || pdp.dataset.nbInit) return; pdp.dataset.nbInit = '1';
    var data; try { data = JSON.parse($('[data-nb-pdp-json]', pdp).textContent); } catch (e) { return; }
    var low = data.low || 2, wa = data.wa || '';
    var idInput = $('[data-nb-variant-id]', pdp);
    var opt = $('[data-nb-opt]', pdp);
    var addBtn = $('[data-nb-add-main]', pdp), buyBtn = $('[data-nb-buy-now]', pdp);
    var stock = $('[data-nb-stock]', pdp), stockTxt = $('[data-nb-stock-txt]', pdp);
    var buy = $('[data-nb-buy]', pdp), notify = $('[data-nb-notify]', pdp), notifyA = $('[data-nb-notify-link]', pdp);
    var sticky = $('[data-nb-sticky]', pdp), stickyBtn = $('[data-nb-sticky-btn]', pdp);
    var selected = data.single ? data.variants[0] : null;
    var addLabel = addBtn ? addBtn.textContent : 'Agregar al carrito';

    pushRecent(data.handle);

    function setVariant(v) {
      selected = v;
      if (idInput) idInput.value = v ? v.id : '';
      var needSize = !v && !data.single;
      if (addBtn) addBtn.textContent = needSize ? 'Seleccioná un talle' : addLabel;
      if (stickyBtn) stickyBtn.textContent = needSize ? 'Seleccioná un talle' : (v && !v.available ? 'Avisame' : 'Agregar');
      if (opt) opt.classList.remove('is-error');
      $$('.nb-size', opt || pdp).forEach(function (b) { b.setAttribute('aria-pressed', v && String(b.getAttribute('data-vid')) === String(v.id) ? 'true' : 'false'); });
      var lbl = $('[data-nb-opt-val]', pdp); if (lbl) lbl.textContent = v ? v.title : '';
      if (stock) {
        var q = v && v.tracked ? v.qty : null;
        if (v && v.available && q !== null && q > 0 && q <= low) { stock.hidden = false; stockTxt.textContent = q === 1 ? 'Última unidad en este talle' : 'Últimas ' + q + ' unidades en este talle'; }
        else stock.hidden = true;
      }
      var out = v ? !v.available : !data.available;
      if (buy) buy.hidden = !!(v && out);
      if (notify) {
        notify.hidden = !out || !wa;
        if (v && out && notifyA && wa) notifyA.href = 'https://wa.me/' + wa + '?text=' + encodeURIComponent('Hola NØBASIC! Quiero que me avisen cuando vuelva ' + data.title + ' en talle ' + v.title + '. ' + location.origin + data.url);
      }
      if (v) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {} }
    }
    function requireSize() {
      if (selected) return true;
      if (opt) { opt.classList.add('is-error'); opt.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); var f = opt.querySelector('.nb-size:not([disabled])'); if (f) f.focus({ preventScroll: true }); }
      return false;
    }
    NB.pdpChoose = function (title) {
      var v = data.variants.filter(function (x) { return x.title === title; })[0];
      if (v) { setVariant(v); var d = $('[data-nb-size-dlg]'); if (d && d.open) d.close(); }
    };
    $$('.nb-size', opt || document.createElement('div')).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var v = data.variants.filter(function (x) { return String(x.id) === b.getAttribute('data-vid'); })[0];
        if (v) setVariant(v);
      });
    });
    var sel = $('[data-nb-variant-select]', pdp);
    if (sel) sel.addEventListener('change', function () { var v = data.variants.filter(function (x) { return String(x.id) === sel.value; })[0]; setVariant(v || null); });

    // talle preseleccionado solo si viene en la URL (?variant=)
    var urlV = new URLSearchParams(location.search).get('variant');
    if (urlV) { var pv = data.variants.filter(function (x) { return String(x.id) === urlV; })[0]; if (pv) setVariant(pv); }
    else setVariant(selected);

    if (addBtn) addBtn.addEventListener('click', function (e) {
      e.preventDefault(); if (!requireSize()) return;
      addToCart(selected.id, 1, addBtn).then(function (ok) { if (ok) openCart(); });
    });
    if (buyBtn) buyBtn.addEventListener('click', function (e) {
      e.preventDefault(); if (!requireSize()) return;
      addToCart(selected.id, 1, buyBtn).then(function (ok) { if (ok) location.href = '/checkout'; });
    });
    if (stickyBtn) stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!selected) { requireSize(); return; }
      if (!selected.available) { if (notify) notify.scrollIntoView({ block: 'center' }); return; }
      addToCart(selected.id, 1, stickyBtn).then(function (ok) { if (ok) openCart(); });
    });
    if (sticky && buy && 'IntersectionObserver' in window) {
      var target = $('[data-nb-buy-zone]', pdp) || buy;
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { var past = !x.isIntersecting; sticky.classList.toggle('is-on', past); sticky.setAttribute('aria-hidden', past ? 'false' : 'true'); });
      }, { threshold: 0 }).observe(target);
    }

    // galería
    var track = $('[data-nb-gal]', pdp);
    if (track) {
      var slides = $$('.nb-gal__slide', track), cnt = $('[data-nb-gal-count]', pdp);
      var gp = $('[data-nb-gal-prev]', pdp), gn = $('[data-nb-gal-next]', pdp), thumbs = $$('[data-nb-thumb]', pdp);
      var cur = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
      var upd = function () {
        var i = cur(); if (cnt) cnt.textContent = (i + 1) + ' / ' + slides.length;
        if (gp) gp.hidden = i <= 0; if (gn) gn.hidden = i >= slides.length - 1;
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      };
      var to = function (i) { track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
      track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      if (gp) gp.addEventListener('click', function () { to(cur() - 1); });
      if (gn) gn.addEventListener('click', function () { to(cur() + 1); });
      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { to(n); }); });
      upd();
    }

    // banda de confianza rotativa
    var rot = $$('[data-nb-trust] li', pdp);
    if (rot.length > 1 && !reduce) { var ri = 0; setInterval(function () { rot[ri].classList.remove('is-on'); ri = (ri + 1) % rot.length; rot[ri].classList.add('is-on'); }, 3400); }

    initSizeDialog(data);
    initAccordions(pdp);

    // Completá el look + vistos recientemente
    var look = $('[data-nb-look]');
    if (look) loadReco(data.id, [data.handle], 10).then(function (cards) {
      var row = look.querySelector('[data-nb-row]'); if (!cards.length || !row) { look.hidden = true; return; }
      fillRow(row, cards, 10); look.hidden = false;
    });
    var rec = $('[data-nb-recent]');
    if (rec) {
      var hs = lsGet('nb-recent', []).filter(function (h) { return h !== data.handle; }).slice(0, 8);
      if (!hs.length) rec.hidden = true;
      else renderHandles(hs, rec.querySelector('[data-nb-row]')).then(function (n) { rec.hidden = !n; });
    }
  }

  /* ---------- tabla de talles + Encontrá tu talle ---------- */
  function parseTable(txt) {
    var rows = (txt || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean)
      .map(function (l) { return l.split('|').map(function (c) { return c.trim(); }); });
    if (rows.length < 2) return null;
    var head = rows[0];
    var sizes = head.length > rows[1].length - 1 ? head.slice(head.length - (rows[1].length - 1)) : head;
    return { sizes: sizes, rows: rows.slice(1).map(function (r) { return { name: r[0], vals: r.slice(1).map(function (v) { var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? null : n; }), raw: r.slice(1) }; }) };
  }
  function initSizeDialog(data) {
    var dlg = $('[data-nb-size-dlg]'); if (!dlg) return;
    $$('[data-nb-size-open]').forEach(function (b) { b.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-nb-dlg-close]')) dlg.close(); });
    var tbl = parseTable(data.table);
    var holder = $('[data-nb-tt]', dlg), finder = $('[data-nb-finder]', dlg);
    if (!tbl || !holder) { if (finder) finder.hidden = true; return; }
    var h = '<div class="nb-tt-wrap"><table class="nb-tt"><thead><tr><th scope="col">Medida (cm)</th>';
    tbl.sizes.forEach(function (s, i) { h += '<th scope="col" data-col="' + i + '">' + s + '</th>'; });
    h += '</tr></thead><tbody>';
    tbl.rows.forEach(function (r) { h += '<tr><th scope="row">' + r.name + '</th>'; r.raw.forEach(function (v, i) { h += '<td data-col="' + i + '">' + v + '</td>'; }); h += '</tr>'; });
    holder.innerHTML = h + '</tbody></table></div>';

    var waist = tbl.rows.filter(function (r) { return /cintura/i.test(r.name); })[0];
    var chest = tbl.rows.filter(function (r) { return /pecho/i.test(r.name); })[0];
    var row = waist || chest;
    if (!row || !finder) { if (finder) finder.hidden = true; return; }
    finder.hidden = false;
    var how = $('[data-nb-finder-how]', finder), lab = $('[data-nb-finder-label]', finder);
    if (waist) { if (lab) lab.textContent = 'Tu medida de cintura (cm)'; if (how) how.textContent = how.getAttribute('data-waist'); }
    else { if (lab) lab.textContent = 'Ancho de pecho de una prenda tuya (cm)'; if (how) how.textContent = how.getAttribute('data-chest'); }
    var input = $('[data-nb-finder-input]', finder), res = $('[data-nb-finder-res]', finder);
    var fit = 0;
    $$('[data-nb-fit]', finder).forEach(function (b) {
      b.addEventListener('click', function () { fit = parseInt(b.getAttribute('data-nb-fit'), 10); $$('[data-nb-fit]', finder).forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); }); calc(); });
    });
    function calc() {
      var m = parseFloat(String(input.value).replace(',', '.'));
      $$('.is-rec', holder).forEach(function (c) { c.classList.remove('is-rec'); });
      if (!m || m <= 0) { res.hidden = true; return; }
      var idx = -1;
      if (waist) {
        for (var i = 0; i < row.vals.length; i++) { if (row.vals[i] !== null && row.vals[i] >= m) { idx = i; break; } }
        if (idx === -1) idx = row.vals.length - 1;
      } else {
        var best = Infinity; row.vals.forEach(function (v, i) { if (v === null) return; var d = Math.abs(v - m); if (d < best) { best = d; idx = i; } });
      }
      idx = Math.max(0, Math.min(tbl.sizes.length - 1, idx + fit));
      var size = tbl.sizes[idx];
      $$('[data-col="' + idx + '"]', holder).forEach(function (c) { c.classList.add('is-rec'); });
      var v = data.variants.filter(function (x) { return String(x.title).toLowerCase() === String(size).toLowerCase(); })[0];
      var html = 'Te recomendamos el talle <b>' + size + '</b>.';
      if (v && v.available) html += '<br><button type="button" class="nb-btn nb-btn--block" data-nb-pick="' + size + '">Elegir talle ' + size + '</button>';
      else if (v) html += '<br>Ese talle está agotado ahora.' + (data.wa ? ' <a href="https://wa.me/' + data.wa + '?text=' + encodeURIComponent('Hola NØBASIC! Quiero que me avisen cuando vuelva ' + data.title + ' en talle ' + size) + '" target="_blank" rel="noopener">Avisame cuando vuelva</a>' : '');
      res.innerHTML = html; res.hidden = false;
      var pick = res.querySelector('[data-nb-pick]'); if (pick) pick.addEventListener('click', function () { NB.pdpChoose(size); });
    }
    if (input) input.addEventListener('input', calc);
  }

  /* ---------- página de favoritos ---------- */
  function initFavPage(root) {
    var box = $('[data-nb-favpage]', root); if (!box) return;
    var favs = getFavs(), grid = box.querySelector('[data-nb-grid]'), empty = box.querySelector('[data-nb-fav-empty]');
    if (!favs.length) { empty.hidden = false; return; }
    Promise.all(favs.map(fetchCard)).then(function (cards) {
      cards = cards.filter(Boolean); grid.innerHTML = '';
      cards.forEach(function (c) { grid.appendChild(c); }); initCards(grid); syncFavs();
      empty.hidden = !!cards.length;
    });
    document.addEventListener('click', function (e) {
      var f = e.target.closest('[data-nb-favpage] [data-nb-fav]');
      if (f) setTimeout(function () { if (getFavs().indexOf(f.getAttribute('data-nb-fav')) === -1) { var c = f.closest('.nb-card'); if (c) c.remove(); if (!grid.children.length) empty.hidden = false; } }, 0);
    });
  }

  /* ---------- arranque ---------- */
  function boot(root) {
    initCards(root); $$('[data-nb-rowwrap]', root).forEach(initRowArrows); initTabs(root); initAccordions(root);
    initCollection(root); initPDP(root); initFavPage(root); syncFavs();
  }
  function start() {
    injectHeaderFav(); boot(document); initHeaderHide();
    var d = getDrawer(); if (d) d.setAttribute('aria-hidden', 'true');
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
